export const SHIPPER_INFOR = 'SHIPPER_INFOR'
export const SHIPPER_INFOR_FAILS = 'SHIPPER_INFOR_FAILS'
export const SHIPPER_INFOR_SUCCESS = 'SHIPPER_INFOR_SUCCESS'

export function shipperInfor(payload) {
    return {
        type: SHIPPER_INFOR,
        payload: payload,
    }
}

export function shipperInforSuccess(payload) {
    return {
        type: SHIPPER_INFOR_SUCCESS,
        payload: payload,
    }
}

export function shipperInforFails(payload) {
    return {
        type: SHIPPER_INFOR_FAILS,
        payload: payload,
    }
}


// WEBPACK FOOTER //
// ./src/actions/shipperInfor.js